import { Component, Input } from '@angular/core';

// There's another component with a similar name
@Component({
  styles: [`
    @media print {
      #show-content * {
        visibility: visible !important;
      }
    }`
  ],
  selector: 'app-quest-unc-resp',
  templateUrl: './question-unconformity-response.component.html',
})
export class QuestUncRespComponent {
  @Input() quesUncResp: any;
  @Input() i: number;

  // required to show attachments
  uploadPath: string = localStorage.getItem("apiIP") + "/upload";
  @Input() getFullPath: Function = () => '';
  @Input() bigSize: boolean = false;
  @Input() folderPath: string = '';
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/question-unconformity-response/question-unconformity-response.component.ts